import { IconToggleButton, LuIcon } from "@overmap-ai/blocks"
import { type ComponentPropsWithRef, memo, useCallback } from "react"

import { useEditorFocused, useFallbackEditor, useTaskListState } from "../../hooks"
import { tipTapIconMapping } from "../mappings"
import type { OptionalEditorProps } from "../typings"

interface TasklistToggleButtonProps
	extends Omit<ComponentPropsWithRef<typeof IconToggleButton>, "children">, OptionalEditorProps {}

export const TasklistToggleButton = memo<TasklistToggleButtonProps>((props) => {
	const { ref, editor: editorFromProps, pressed, onPressedChange, disabled, ...rest } = props

	const editor = useFallbackEditor(editorFromProps)
	const isEditorFocused = useEditorFocused(editor)
	const state = useTaskListState(editor)

	const handlePressedChange = useCallback(
		(pressed: boolean) => {
			onPressedChange?.(pressed)
			editor?.chain().focus().toggleTaskList().run()
		},
		[editor, onPressedChange],
	)

	return (
		<IconToggleButton
			ref={ref}
			pressed={pressed ?? (state.isActive && isEditorFocused)}
			onPressedChange={handlePressedChange}
			disabled={disabled ?? !state.canToggle}
			{...rest}
		>
			<LuIcon icon={tipTapIconMapping.taskList} />
		</IconToggleButton>
	)
})
TasklistToggleButton.displayName = "TasklistToggleButton"
